module.exports = "/_next/static/images/grid-dbdd4691ef3f7f7a71690e3f7a4538e3.svg";